// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_MonadZero = require("../Control.MonadZero/index.js");
var Data_Argonaut_Decode_Class = require("../Data.Argonaut.Decode.Class/index.js");
var Data_Argonaut_Encode_Class = require("../Data.Argonaut.Encode.Class/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Bifunctor = require("../Data.Bifunctor/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Filterable = require("../Data.Filterable/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Graph = require("../Data.Graph/index.js");
var Data_HeytingAlgebra = require("../Data.HeytingAlgebra/index.js");
var Data_Lens_At = require("../Data.Lens.At/index.js");
var Data_Lens_Index = require("../Data.Lens.Index/index.js");
var Data_Lens_Internal_Wander = require("../Data.Lens.Internal.Wander/index.js");
var Data_Lens_Lens = require("../Data.Lens.Lens/index.js");
var Data_List_Types = require("../Data.List.Types/index.js");
var Data_Map = require("../Data.Map/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Set = require("../Data.Set/index.js");
var Data_Traversable = require("../Data.Traversable/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Data_Unfoldable = require("../Data.Unfoldable/index.js");
var Graph = function (x) {
    return x;
};
var toUnfoldable = function (dictUnfoldable) {
    return function (dictOrd) {
        return function (v) {
            return Data_Map_Internal.toUnfoldable(dictUnfoldable)(Data_Functor.map(Data_Map_Internal.functorMap)(Data_Tuple.fst)(v));
        };
    };
};
var singleton = function (dictOrd) {
    return function (k) {
        return function (v) {
            return Graph(Data_Map_Internal.singleton(k)(new Data_Tuple.Tuple(v, Data_Set.empty)));
        };
    };
};
var showGraph = function (dictShow) {
    return function (dictShow1) {
        return Data_Map_Internal.showMap(dictShow)(Data_Tuple.showTuple(dictShow1)(Data_Set.showSet(dictShow)));
    };
};
var semigroupGraph = function (dictOrd) {
    return function (dictSemigroup) {
        return new Data_Semigroup.Semigroup(function (v) {
            return function (v1) {
                var f = function (v2) {
                    return function (v3) {
                        return Data_Tuple.Tuple.create(Data_Semigroup.append(dictSemigroup)(v2.value0)(v3.value0))(Data_Set.union(dictOrd)(v2.value1)(v3.value1));
                    };
                };
                return Graph(Data_Map_Internal.unionWith(dictOrd)(f)(v)(v1));
            };
        });
    };
};
var removeEdge = function (dictOrd) {
    return function (from) {
        return function (to) {
            return function (v) {
                return Graph(Data_Map_Internal.alter(dictOrd)(Data_Functor.map(Data_Maybe.functorMaybe)(Data_Bifunctor.rmap(Data_Tuple.bifunctorTuple)(Data_Set["delete"](dictOrd)(to))))(from)(v));
            };
        };
    };
};
var parents = function (dictOrd) {
    return function (k) {
        return function (v) {
            return Data_Map.keys(Data_Map_Internal.filter(dictOrd)((function () {
                var $137 = Data_Foldable.elem(Data_Set.foldableSet)(dictOrd.Eq0())(k);
                return function ($138) {
                    return $137(Data_Tuple.snd($138));
                };
            })())(v));
        };
    };
};
var newtypeGraph = new Data_Newtype.Newtype(function (n) {
    return n;
}, Graph);
var size = function (dictOrd) {
    var $139 = Data_Newtype.unwrap(newtypeGraph);
    return function ($140) {
        return Data_Map_Internal.size($139($140));
    };
};
var toMap = function (dictOrd) {
    var $141 = Data_Functor.map(Data_Map_Internal.functorMap)(Data_Tuple.fst);
    var $142 = Data_Newtype.unwrap(newtypeGraph);
    return function ($143) {
        return $141($142($143));
    };
};
var topologicalSort = function (dictOrd) {
    var $144 = Data_Graph.topologicalSort(dictOrd);
    var $145 = Data_Newtype.unwrap(newtypeGraph);
    return function ($146) {
        return $144(Data_Graph.fromMap($145($146)));
    };
};
var vertices = function (dictOrd) {
    var $147 = Data_Functor.map(Data_List_Types.functorList)(Data_Tuple.fst);
    var $148 = Data_Newtype.unwrap(newtypeGraph);
    return function ($149) {
        return $147(Data_Map_Internal.values($148($149)));
    };
};
var lookup = function (dictOrd) {
    return function (k) {
        var $150 = Data_Functor.map(Data_Maybe.functorMaybe)(Data_Tuple.fst);
        var $151 = Data_Map_Internal.lookup(dictOrd)(k);
        var $152 = Data_Newtype.unwrap(newtypeGraph);
        return function ($153) {
            return $150($151($152($153)));
        };
    };
};
var keys = function (dictOrd) {
    var $154 = Data_Newtype.unwrap(newtypeGraph);
    return function ($155) {
        return Data_Map.keys($154($155));
    };
};
var insertEdge = function (dictOrd) {
    return function (from) {
        return function (to) {
            return function (v) {
                return Graph(Data_Map_Internal.alter(dictOrd)(Data_Functor.map(Data_Maybe.functorMaybe)(Data_Bifunctor.rmap(Data_Tuple.bifunctorTuple)(Data_Set.insert(dictOrd)(to))))(from)(v));
            };
        };
    };
};
var insert = function (dictOrd) {
    return function (key) {
        return function (value) {
            return function (v) {
                return Graph(Data_Map_Internal.alter(dictOrd)((function () {
                    var $156 = Data_Maybe.maybe(new Data_Tuple.Tuple(value, Data_Set.empty))(Data_Bifunctor.lmap(Data_Tuple.bifunctorTuple)(Data_Function["const"](value)));
                    return function ($157) {
                        return Data_Maybe.Just.create($156($157));
                    };
                })())(key)(v));
            };
        };
    };
};
var indexGraph = function (dictOrd) {
    return new Data_Lens_Index.Index(function (k) {
        return function (dictWander) {
            return Data_Lens_Internal_Wander.wander(dictWander)(function (dictApplicative) {
                return function (coalg) {
                    return function (m) {
                        return Data_Maybe.maybe(Control_Applicative.pure(dictApplicative)(m))((function () {
                            var $158 = Data_Functor.map((dictApplicative.Apply0()).Functor0())(function (v) {
                                return insert(dictOrd)(k)(v)(m);
                            });
                            return function ($159) {
                                return $158(coalg($159));
                            };
                        })())(lookup(dictOrd)(k)(m));
                    };
                };
            });
        };
    });
};
var functorGraph = function (dictOrd) {
    return new Data_Functor.Functor(function (f) {
        return function (v) {
            return Data_Functor.map(Data_Map_Internal.functorMap)(Data_Bifunctor.lmap(Data_Tuple.bifunctorTuple)(f))(v);
        };
    });
};
var foldableGraph = function (dictOrd) {
    return new Data_Foldable.Foldable(function (dictMonoid) {
        return function (f) {
            var $160 = Data_Foldable.foldMap(Data_Map_Internal.foldableMap)(dictMonoid)(function ($163) {
                return f(Data_Tuple.fst($163));
            });
            var $161 = Data_Newtype.unwrap(newtypeGraph);
            return function ($162) {
                return $160($161($162));
            };
        };
    }, function (f) {
        return Data_Foldable.foldlDefault(foldableGraph(dictOrd))(f);
    }, function (f) {
        return Data_Foldable.foldrDefault(foldableGraph(dictOrd))(f);
    });
};
var traversableGraph = function (dictOrd) {
    return new Data_Traversable.Traversable(function () {
        return foldableGraph(dictOrd);
    }, function () {
        return functorGraph(dictOrd);
    }, function (dictApplicative) {
        return Data_Traversable.sequenceDefault(traversableGraph(dictOrd))(dictApplicative);
    }, function (dictApplicative) {
        return function (f) {
            return function (v) {
                var f$prime = function (v1) {
                    return function (k) {
                        return Data_Functor.map((dictApplicative.Apply0()).Functor0())(Data_Function.flip(Data_Tuple.Tuple.create)(k))(f(v1));
                    };
                };
                return Data_Functor.map((dictApplicative.Apply0()).Functor0())(Graph)(Data_Traversable.traverse(Data_Map_Internal.traversableMap)(dictApplicative)(Data_Tuple.uncurry(f$prime))(v));
            };
        };
    });
};
var filterVertices = function (dictOrd) {
    return function (filterFunction) {
        var $164 = Data_Filterable.filter(Data_Filterable.filterableMap(dictOrd))(function ($167) {
            return filterFunction(Data_Tuple.fst($167));
        });
        var $165 = Data_Newtype.unwrap(newtypeGraph);
        return function ($166) {
            return Graph($164($165($166)));
        };
    };
};
var eqGraph = function (dictEq) {
    return function (dictEq1) {
        return new Data_Eq.Eq(function (x) {
            return function (y) {
                return Data_Eq.eq(Data_Map_Internal.eqMap(dictEq)(Data_Tuple.eqTuple(dictEq1)(Data_Set.eqSet(dictEq))))(x)(y);
            };
        });
    };
};
var ordGraph = function (dictOrd) {
    return function (dictOrd1) {
        return new Data_Ord.Ord(function () {
            return eqGraph(dictOrd.Eq0())(dictOrd1.Eq0());
        }, function (x) {
            return function (y) {
                return Data_Ord.compare(Data_Map_Internal.ordMap(dictOrd)(Data_Tuple.ordTuple(dictOrd1)(Data_Set.ordSet(dictOrd))))(x)(y);
            };
        });
    };
};
var encodeJsonGraph = function (dictOrd) {
    return function (dictEncodeJson) {
        return function (dictEncodeJson1) {
            return Data_Argonaut_Encode_Class.encodeMap(dictOrd)(dictEncodeJson)(Data_Argonaut_Encode_Class.encodeJsonTuple(dictEncodeJson1)(Data_Argonaut_Encode_Class.encodeSet(dictOrd)(dictEncodeJson)));
        };
    };
};
var emptyGraph = function (dictOrd) {
    return Graph(Data_Map_Internal.empty);
};
var monoidGraph = function (dictOrd) {
    return function (dictSemigroup) {
        return new Data_Monoid.Monoid(function () {
            return semigroupGraph(dictOrd)(dictSemigroup);
        }, emptyGraph(dictOrd));
    };
};
var edges = function (dictUnfoldable) {
    return function (dictOrd) {
        return function (v) {
            var edgeArray = Control_Bind.bind(Control_Bind.bindArray)(Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray)(v))(function (v1) {
                return Data_Functor.map(Data_Functor.functorArray)(Data_Tuple.Tuple.create(v1.value0))(Data_Set.toUnfoldable(Data_Unfoldable.unfoldableArray)(v1.value1.value1));
            });
            return Data_Array.toUnfoldable(dictUnfoldable)(edgeArray);
        };
    };
};
var invert = function (dictOrd) {
    return function (v) {
        var edgeList = edges(Data_Unfoldable.unfoldableArray)(dictOrd)(v);
        var go = function (key) {
            return function (v1) {
                return Data_Maybe.Just.create(Data_Tuple.Tuple.create(v1.value0)(Data_Set.fromFoldable(Data_Foldable.foldableArray)(dictOrd)(Data_Filterable.filterMap(Data_Filterable.filterableArray)(Data_Tuple.uncurry(Data_Function.flip((function () {
                    var $168 = Data_Functor.voidLeft(Data_Maybe.functorMaybe);
                    var $169 = Control_MonadZero.guard(Data_Maybe.monadZeroMaybe);
                    var $170 = Data_Eq.eq(dictOrd.Eq0())(key);
                    return function ($171) {
                        return $168($169($170($171)));
                    };
                })())))(edgeList))));
            };
        };
        return Graph(Data_Map_Internal.mapMaybeWithKey(dictOrd)(go)(v));
    };
};
var $$delete = function (dictOrd) {
    return function (key) {
        var parents$prime = function (graph) {
            return Data_Foldable.foldr(Data_Set.foldableSet)(Data_Function.flip(removeEdge(dictOrd))(key))(graph)(parents(dictOrd)(key)(graph));
        };
        var $172 = Data_Newtype.over(newtypeGraph)(newtypeGraph)(Graph)(Data_Map_Internal["delete"](dictOrd)(key));
        return function ($173) {
            return parents$prime($172($173));
        };
    };
};
var decodeJsonGraph = function (dictOrd) {
    return function (dictDecodeJson) {
        return function (dictDecodeJson1) {
            return Data_Argonaut_Decode_Class.decodeMap(dictOrd)(dictDecodeJson)(Data_Argonaut_Decode_Class.decodeJsonTuple(dictDecodeJson1)(Data_Argonaut_Decode_Class.decodeSet(dictOrd)(dictDecodeJson)));
        };
    };
};
var children = function (dictOrd) {
    return function (k) {
        return function (v) {
            return Data_Maybe.maybe(Data_Monoid.mempty(Data_Set.monoidSet(dictOrd)))((function () {
                var $174 = Data_Set.fromFoldable(Data_Set.foldableSet)(dictOrd);
                return function ($175) {
                    return $174(Data_Tuple.snd($175));
                };
            })())(Data_Map_Internal.lookup(dictOrd)(k)(v));
        };
    };
};
var isInCycle = function (dictOrd) {
    return function (k$prime) {
        return function (g) {
            var go = function (seen) {
                return function (k) {
                    var dd = children(dictOrd)(k)(g);
                    var v = new Data_Tuple.Tuple(Data_Eq.eq(Data_Set.eqSet(dictOrd.Eq0()))(dd)(Data_Monoid.mempty(Data_Set.monoidSet(dictOrd))), Data_Set.member(dictOrd)(k)(seen));
                    if (v.value0) {
                        return false;
                    };
                    if (v.value1) {
                        return Data_Eq.eq(dictOrd.Eq0())(k)(k$prime);
                    };
                    if (!v.value0 && !v.value1) {
                        return Data_Foldable.any(Data_Set.foldableSet)(Data_HeytingAlgebra.heytingAlgebraBoolean)(go(Data_Set.insert(dictOrd)(k)(seen)))(dd);
                    };
                    throw new Error("Failed pattern match at Lunarbox.Data.Graph (line 138, column 15 - line 141, column 66): " + [ v.constructor.name ]);
                };
            };
            return go(Data_Monoid.mempty(Data_Set.monoidSet(dictOrd)))(k$prime);
        };
    };
};
var isCyclic = function (dictOrd) {
    return function (g) {
        return Data_Foldable.any(Data_Set.foldableSet)(Data_HeytingAlgebra.heytingAlgebraBoolean)(Data_Function.flip(isInCycle(dictOrd))(g))(keys(dictOrd)(g));
    };
};
var wouldCreateCycle = function (dictOrd) {
    return function (from) {
        return function (to) {
            var $176 = isCyclic(dictOrd);
            var $177 = insertEdge(dictOrd)(from)(to);
            return function ($178) {
                return $176($177($178));
            };
        };
    };
};
var isInOutsideCycle = function (dictOrd) {
    return function (k$prime) {
        return function (g) {
            var go = function (seen) {
                return function (k) {
                    var dd = Data_Set.difference(dictOrd)(children(dictOrd)(k)(g))(Data_Set.singleton(k));
                    var v = new Data_Tuple.Tuple(Data_Eq.eq(Data_Set.eqSet(dictOrd.Eq0()))(dd)(Data_Monoid.mempty(Data_Set.monoidSet(dictOrd))), Data_Set.member(dictOrd)(k)(seen));
                    if (v.value0) {
                        return false;
                    };
                    if (v.value1) {
                        return Data_Eq.eq(dictOrd.Eq0())(k)(k$prime);
                    };
                    if (!v.value0 && !v.value1) {
                        return Data_Foldable.any(Data_Set.foldableSet)(Data_HeytingAlgebra.heytingAlgebraBoolean)(go(Data_Set.insert(dictOrd)(k)(seen)))(dd);
                    };
                    throw new Error("Failed pattern match at Lunarbox.Data.Graph (line 149, column 15 - line 152, column 66): " + [ v.constructor.name ]);
                };
            };
            return go(Data_Monoid.mempty(Data_Set.monoidSet(dictOrd)))(k$prime);
        };
    };
};
var hasBigCycle = function (dictOrd) {
    return function (g) {
        return Data_Foldable.any(Data_Set.foldableSet)(Data_HeytingAlgebra.heytingAlgebraBoolean)(Data_Function.flip(isInOutsideCycle(dictOrd))(g))(keys(dictOrd)(g));
    };
};
var wouldCreateLongCycle = function (dictOrd) {
    return function (from) {
        return function (to) {
            var $179 = hasBigCycle(dictOrd);
            var $180 = insertEdge(dictOrd)(from)(to);
            return function ($181) {
                return $179($180($181));
            };
        };
    };
};
var atGraph = function (dictOrd) {
    return new Data_Lens_At.At(function () {
        return indexGraph(dictOrd);
    }, function (k) {
        return function (dictStrong) {
            return Data_Lens_Lens.lens(lookup(dictOrd)(k))(function (m) {
                return Data_Maybe.maybe($$delete(dictOrd)(k)(m))(function (v) {
                    return insert(dictOrd)(k)(v)(m);
                });
            })(dictStrong);
        };
    });
};
module.exports = {
    Graph: Graph,
    filterVertices: filterVertices,
    emptyGraph: emptyGraph,
    toMap: toMap,
    singleton: singleton,
    insert: insert,
    lookup: lookup,
    "delete": $$delete,
    keys: keys,
    vertices: vertices,
    toUnfoldable: toUnfoldable,
    insertEdge: insertEdge,
    removeEdge: removeEdge,
    edges: edges,
    children: children,
    isInCycle: isInCycle,
    isInOutsideCycle: isInOutsideCycle,
    isCyclic: isCyclic,
    hasBigCycle: hasBigCycle,
    topologicalSort: topologicalSort,
    parents: parents,
    wouldCreateCycle: wouldCreateCycle,
    wouldCreateLongCycle: wouldCreateLongCycle,
    size: size,
    invert: invert,
    newtypeGraph: newtypeGraph,
    eqGraph: eqGraph,
    ordGraph: ordGraph,
    showGraph: showGraph,
    encodeJsonGraph: encodeJsonGraph,
    decodeJsonGraph: decodeJsonGraph,
    functorGraph: functorGraph,
    semigroupGraph: semigroupGraph,
    monoidGraph: monoidGraph,
    foldableGraph: foldableGraph,
    traversableGraph: traversableGraph,
    indexGraph: indexGraph,
    atGraph: atGraph
};
